import React, { isValidElement } from "react";
import ChrInfoPopover from "../../../Form/Basic/ChrInfoPopover";

/*
props = {
  header: <ReactComponent>
}

props = {
  header: {
    text: string,
    helpText: string <optional>
  }
}
*/

const Header = (props) => {
  const { header=<React.Fragment />, headerClass='' } = props;
  if(isValidElement(header)) return header;

  const { text, helpText } = header;

  return (
    <div aria-label={text} className="d-flex align-items-center">
      <span aria-hidden="true" className={`p-2 chr-off-canvas-header ${headerClass}`}>
        {text}
      </span>
      {
        helpText && <ChrInfoPopover
          html
          delay={500}
          boundary="body"
          content={helpText}
          placement="auto"
          useTemplate
          templateOptions={{ wrapperOptions: { className: "chr-off-canvas-tooltip" }, bodyOptions: { className: "text-default-important" }}}
          additionalIconClass="text-info"
          trigger="click hover"
        />
      }
    </div>
  );
}

export default Header;